import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExportMenu from "../../../../../Common/ExportMenu/ExportMenu";
import { useAttendanceStore } from "../store/useAttendanceStore";
import { formatDateTimeWithoutSec } from "../../../../../Common/helper/helpar";


export const ExportZoneLevelDrillDown = () => {
  const { zoneLevelDetails } = useAttendanceStore();
  const downloadExcel = async () => {
    const filters = localStorage.getItem("sat-trips-zone-filters");
    const { FromDateTime, ToDateTime } = filters ? JSON.parse(filters) : {};

    // Get current date/time for header
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const filterDateRange =
      FromDateTime && ToDateTime
        ? `(${formatDateTimeWithoutSec(
            FromDateTime
          )} to ${formatDateTimeWithoutSec(ToDateTime)})`
        : "";
    const reportTitle = `Zone Level Drill Down ${filterDateRange}`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zone Report");

    const boldFont = { bold: true };
    const centerAlignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true,
    };

    // --- Header Row 1: Report Title ---
    const headerRow1 = worksheet.addRow([generatedText]);
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, 8);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    // --- Header Row 2: Generated Date/Time ---
    const headerRow2 = worksheet.addRow([reportTitle]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, 8);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    // --- Table Header Row ---
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Operation Name",
      "Designation",
      "Planned Attendance",
      "Biometric Attendance",
      "Forced Attendance",
      "BA + FA",
      "Shortfall",
      "Attendance %",
    ]);
    tableHeaderRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
    });

    // --- Data Rows ---
    zoneLevelDetails.forEach((item, index) => {
      const row = worksheet.addRow([
        index + 1,
        item.operationName,
        item.designationName,
        item.plannedAttendance,
        item.biometricAttendance,
        item.forcedAttendance,
        item.bA_FA,
        item.shortfall,
        item.attendancePercentage,
      ]);
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    // --- Adjust Column Widths ---
    worksheet.columns = [
      { width: 10 }, // S.No
      { width: 20 }, // Zone
      { width: 20 }, // Planned Attendance
      { width: 20 }, // Biometric Attendance
      { width: 20 }, // Forced Attendance
      { width: 20 }, // BA + FA
      { width: 15 }, // Shortfall
      { width: 15 }, // Shortfall
      { width: 15 }, // Attendance %
      { width: 15 }, // Attendance %
    ];

    // --- Save and Download Workbook ---
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ZoneLevelDrillDown.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    const filters = localStorage.getItem("sat-trips-zone-filters");
    const { FromDateTime, ToDateTime } = filters ? JSON.parse(filters) : {};

    const filterDateRange =
      FromDateTime && ToDateTime
        ? `(${formatDateTimeWithoutSec(
            FromDateTime
          )} to ${formatDateTimeWithoutSec(ToDateTime)})`
        : "";

    const reportTitle = `Zone Level Drill Down ${filterDateRange}`;

    // doc.text("Zone Level Drill Down", 10, 10);
    doc.text(reportTitle, 10, 20);

    const tableData = zoneLevelDetails.map((item, index) => [
      index + 1,
      item.operationName,
      item.designationName,
      item.plannedAttendance,
      item.biometricAttendance,
      item.forcedAttendance,
      item.bA_FA,
      item.shortfall,
      item.attendancePercentage,
    ]);

    autoTable(doc, {
      head: [
        [
          "S.No",
          "Operation Name",
          "Designation",
          "Planned Attendance",
          "Biometric Attendance",
          "Forced Attendance",
          "BA + FA",
          "Shortfall",
          "Attendance %",
        ],
      ],
      body: tableData,
      startY: 30,
      startX: 10,
      theme: "striped",
      headStyles: { fillColor: [246, 177, 177] },
      columnStyles: {
        0: { cellWidth: 10 }, // S.No
        1: { cellWidth: 25 }, // Operation Name
        2: { cellWidth: 25 }, // Designation
        3: { cellWidth: 25 }, // Planned Attendance
        4: { cellWidth: 25 }, // Biometric Attendance
        5: { cellWidth: 25 }, // Forced Attendance
        6: { cellWidth: 20 }, // BA + FA
        7: { cellWidth: 20 }, // Shortfall
        8: { cellWidth: 20 }, // Attendance %
      },
    });

    doc.save("ZoneLevelDrillDown.pdf");
  };

  return (
    <ExportMenu
      items={[
        { label: "Excel", icon: "fa-solid fa-file-excel", onClick: downloadExcel },
        { label: "PDF", icon: "fa-solid fa-file-pdf", onClick: downloadPDF },
      ]}
    />
  );
};
